import { render, staticRenderFns } from "./ChartTopObrasRadio.vue?vue&type=template&id=13035b31&"
import script from "./ChartTopObrasRadio.vue?vue&type=script&lang=js&"
export * from "./ChartTopObrasRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports